/**
 * Fannie DU credit-reissue credentials (DEV-5596), scoped to a SubCompany default and optionally
 * overridden per user (the LO). Rides the SkynetAPI gateway (httpSkynetApi) — same host as the
 * sibling `SubCompanyCeilingDerivationApi` / `SubCompanyPipelineAccessApi` admin-panel endpoints.
 * PUT never accepts a raw password back — the DTO only ever carries `hasPassword`; an omitted
 * `password` on write leaves the stored value unchanged (server-side coalesce).
 */
export class SubCompanyCreditProviderApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  // Degradable broker read: skip the global forbidden-status page-reload interceptor so a failed
  // fetch surfaces the in-tab error+retry state instead of reloading the whole app (matches the
  // sibling SubCompany admin-panel reads).
  async getSubCompanyCreditProvider({ subCompanyId }) {
    return this.#http.get(`/api/admin-panel/sub-companies/${subCompanyId}/credit-provider`, {
      skipResponseInterceptor: { forbiddenError: true },
    });
  }

  async updateSubCompanyCreditProvider({ subCompanyId, provider, userName, password, useTest }) {
    return this.#http.put(`/api/admin-panel/sub-companies/${subCompanyId}/credit-provider`, {
      provider,
      userName,
      password,
      useTest,
    });
  }

  async deleteSubCompanyCreditProvider({ subCompanyId }) {
    return this.#http.delete(`/api/admin-panel/sub-companies/${subCompanyId}/credit-provider`);
  }

  async getUserCreditProvider({ subCompanyId, userId }) {
    return this.#http.get(
      `/api/admin-panel/sub-companies/${subCompanyId}/users/${userId}/credit-provider`,
      { skipResponseInterceptor: { forbiddenError: true } },
    );
  }

  async updateUserCreditProvider({ subCompanyId, userId, provider, userName, password, useTest }) {
    return this.#http.put(
      `/api/admin-panel/sub-companies/${subCompanyId}/users/${userId}/credit-provider`,
      { provider, userName, password, useTest },
    );
  }

  async deleteUserCreditProvider({ subCompanyId, userId }) {
    return this.#http.delete(
      `/api/admin-panel/sub-companies/${subCompanyId}/users/${userId}/credit-provider`,
    );
  }
}
